import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {

  connect() {
    this.popoverTriggers = this.findPopoverTriggers()
    this.popovers = this.popoverTriggers.map((popoverTriggerEl) => {
      const existingPopover = bootstrap.Popover.getInstance(popoverTriggerEl)
      if (existingPopover) return existingPopover

      return new bootstrap.Popover(popoverTriggerEl, {
        html: true
      })
    })

    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.handlePopoverCloseClick = this.handlePopoverCloseClick.bind(this)

    document.addEventListener('click', this.handleDocumentClick)
    document.addEventListener('click', this.handlePopoverCloseClick)
  }

  disconnect() {
    document.removeEventListener('click', this.handleDocumentClick)
    document.removeEventListener('click', this.handlePopoverCloseClick)
  }

  findPopoverTriggers() {
    if (this.element.matches('[data-bs-toggle="popover"]')) return [this.element]

    return [].slice.call(this.element.querySelectorAll('[data-bs-toggle="popover"]'))
  }

  handleDocumentClick(event) {
    const clickedTrigger = this.popoverTriggers.some((trigger) => trigger.contains(event.target))
    const clickedPopover = Boolean(event.target.closest('.popover'))
    if (clickedTrigger || clickedPopover) return

    this.hideAllPopovers()
  }

  handlePopoverCloseClick(event) {
    if (!event.target.closest('.js-popover-close')) return

    this.hideAllPopovers()
  }

  hideAllPopovers() {
    this.popovers.forEach((popover) => {
      popover.hide()
    })
  }

}
